// ─── NEW CONTENT ITEMS ───────────────────────────────────────────────────────
// All proposed new items from the TheBurntPeanut rename master list.
// These are items that DO NOT yet exist in the game.
// Used by the ContentEditor tool (/content-editor route).

export type ContentCategory =
  | 'weapon'
  | 'peanut_perc'
  | 'buncha_bullshiiii'
  | 'shrine'
  | 'enemy';

export type SpriteType = 'sprite_only' | 'needs_animation' | 'undecided';

export interface NewContentItem {
  id: string;
  category: ContentCategory;
  proposedName: string;
  originalDesignName: string;
  effect: string;
  loreReason: string;
  subcategory?: string;
  spriteType: SpriteType;
  notes: string;
  approved: boolean;
}

export const NEW_CONTENT_ITEMS: NewContentItem[] = [
  // ─── WEAPONS ─────────────────────────────────────────────────────────────
  {
    id: 'wpn_goop_beam',
    category: 'weapon',
    proposedName: 'The GOOP Beam',
    originalDesignName: 'Goop Laser',
    effect: 'Continuous beam weapon — strips armor/shields on hit',
    loreReason: 'G.O.O.P. = Gear Off Other Players — the beam that strips loot',
    subcategory: 'Beam',
    spriteType: 'undecided',
    notes: '',
    approved: false,
  },
  {
    id: 'wpn_hutch_sippy_cup',
    category: 'weapon',
    proposedName: "Sippy Cup",
    originalDesignName: 'Sippy Cup Boomerang',
    effect: 'Boomerang projectile — returns to player, hits twice',
    loreReason: "boomerang — always comes back",
    subcategory: 'Boomerang',
    spriteType: 'undecided',
    notes: '',
    approved: false,
  },
  {
    id: 'wpn_big_mac_trap',
    category: 'weapon',
    proposedName: 'Big Mac Trap',
    originalDesignName: 'Crockpot Mine',
    effect: 'Placeable mine — enemies are attracted to it before it explodes',
    loreReason: 'A Big Mac left on the floor — irresistible, deadly',
    subcategory: 'Mine',
    spriteType: 'undecided',
    notes: '',
    approved: false,
  },
  {
    id: 'wpn_karen_drone',
    category: 'weapon',
    proposedName: 'Karen The Drone',
    originalDesignName: 'Helicopter Mom',
    effect: 'Auto-targeting drone orbits player and fires at nearest enemy',
    loreReason: 'Karen The Manager ultra reference — auto-manages enemies',
    subcategory: 'Drone',
    spriteType: 'needs_animation',
    notes: '',
    approved: false,
  },
  {
    id: 'wpn_by_the_gods_slingshot',
    category: 'weapon',
    proposedName: 'By The Gods Slingshot',
    originalDesignName: 'Slingshot Of Justice',
    effect: 'Charge-up shot — hold to charge, release for massive damage',
    loreReason: '"By the gods..." — his exasperated charge-up',
    subcategory: 'Charge',
    spriteType: 'undecided',
    notes: '',
    approved: false,
  },
  {
    id: 'wpn_diarrhea_squirter',
    category: 'weapon',
    proposedName: 'Diarrhea Squirter',
    originalDesignName: 'Habanero Squirter',
    effect: 'Short-range spray weapon — applies burn DoT',
    loreReason: 'Matches existing Diarrhea Gas ultra — same energy',
    subcategory: 'DoT Spray',
    spriteType: 'undecided',
    notes: '',
    approved: false,
  },
  {
    id: 'wpn_chill_pill',
    category: 'weapon',
    proposedName: 'The Chill Pill',
    originalDesignName: 'Tranquilizer Dart Gun',
    effect: 'Slow projectile — hit enemies move at 40% speed for 4s',
    loreReason: '"Chill out" — slows enemies down',
    subcategory: 'Slow',
    spriteType: 'undecided',
    notes: '',
    approved: false,
  },
  {
    id: 'wpn_dracs_fang',
    category: 'weapon',
    proposedName: "Vampire Fang",
    originalDesignName: 'Vampire Fang Knife',
    effect: 'Melee weapon — each hit restores 8% of damage dealt as HP',
    loreReason: "Gas Mask already in game — Vampire Fang is the melee lifesteal version",
    subcategory: 'Lifesteal Melee',
    spriteType: 'undecided',
    notes: '',
    approved: false,
  },
  {
    id: 'wpn_fart_cannon',
    category: 'weapon',
    proposedName: "Peanut's Fart Cannon",
    originalDesignName: 'Stink Bomb Launcher',
    effect: 'Lobs gas cloud — AOE slow + damage over time zone',
    loreReason: 'Crude humor — fits the register perfectly',
    subcategory: 'Smoke/Slow',
    spriteType: 'undecided',
    notes: '',
    approved: false,
  },
  {
    id: 'wpn_kabluwee_spread',
    category: 'weapon',
    proposedName: 'Ka-Bluwee Spread',
    originalDesignName: 'Fan Of Knives',
    effect: 'Fan of 5 piercing projectiles in a spread arc',
    loreReason: '"Ka-dinga! Ka-blam! Ka-bluwee!" — his explosion sound effects',
    subcategory: 'Spread Pierce',
    spriteType: 'undecided',
    notes: '',
    approved: false,
  },

  // ─── PEANUT PERCS — Trade-Off ─────────────────────────────────────────────
  {
    id: 'perc_sponge_mode',
    category: 'peanut_perc',
    proposedName: 'Sponge Mode',
    originalDesignName: 'Glass Bones & Paper Skin',
    effect: '+50% damage dealt, -25 max HP',
    loreReason: '"Sponge" = the character who dies instantly but hits hard',
    subcategory: 'Trade-Off',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_hutchs_armor',
    category: 'peanut_perc',
    proposedName: "Padded Armor",
    originalDesignName: 'Cement Mixer Brain',
    effect: '+30 armor, -30% movement speed',
    loreReason: 'the slow tanky archetype',
    subcategory: 'Trade-Off',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_all_roid_no_lift',
    category: 'peanut_perc',
    proposedName: 'All Roid, No Lift',
    originalDesignName: 'All Roid, No Lift',
    effect: '+75% damage, cannot pick up gold',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Trade-Off',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_last_resort_jr',
    category: 'peanut_perc',
    proposedName: 'Last Resort Jr.',
    originalDesignName: 'Cracked Mirror',
    effect: '+1% damage per 1% missing HP (max +100%)',
    loreReason: 'Pairs with Last Resort item — the comeback kid',
    subcategory: 'Trade-Off',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },

  // ─── PEANUT PERCS — Conditional ──────────────────────────────────────────
  {
    id: 'perc_surrounded_by_bungulators',
    category: 'peanut_perc',
    proposedName: 'Surrounded By Bungulators',
    originalDesignName: 'Cornered Like A Cat',
    effect: '+30% damage when 5+ enemies within 150wu',
    loreReason: 'Bungulators swarming = damage boost',
    subcategory: 'Conditional',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_lets_ride_alone',
    category: 'peanut_perc',
    proposedName: "Let's Ride (Alone)",
    originalDesignName: 'Sweet Solitude',
    effect: '+15% movement speed when no enemies within 300wu',
    loreReason: '"Let\'s ride" — but solo',
    subcategory: 'Conditional',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_roid_rage',
    category: 'peanut_perc',
    proposedName: 'Roid Rage',
    originalDesignName: 'Roid Rage',
    effect: '+30% damage when HP below 30%',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Conditional',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_hes_homeless',
    category: 'peanut_perc',
    proposedName: "He's Homeless",
    originalDesignName: 'Empty Stomach',
    effect: '+50% gold pickup range when no chests have been opened',
    loreReason: '"He\'s homeless" — looting empty bodies',
    subcategory: 'Conditional',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },

  // ─── PEANUT PERCS — Scaling ───────────────────────────────────────────────
  {
    id: 'perc_big_boy_beans',
    category: 'peanut_perc',
    proposedName: 'Big Boy Beans',
    originalDesignName: 'Big Boy Beans',
    effect: '+1% damage per kill, stacks up to 25%',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Scaling',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_per_chance_per_maybe',
    category: 'peanut_perc',
    proposedName: 'Per Chance, Per Maybe',
    originalDesignName: 'Late Bloomer',
    effect: '+0.5% to all stats per minute survived',
    loreReason: '"Per chance, per maybe" — his uncertain hedge phrase',
    subcategory: 'Scaling',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_voodoo_crash',
    category: 'peanut_perc',
    proposedName: 'VooDoo Crash',
    originalDesignName: 'Caffeine Crash',
    effect: '+50% attack speed first 60s, then -25% attack speed after',
    loreReason: 'VooDoo Ranger crash — too much of a good thing',
    subcategory: 'Scaling',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },

  // ─── PEANUT PERCS — Economy ───────────────────────────────────────────────
  {
    id: 'perc_donation_alert_stack',
    category: 'peanut_perc',
    proposedName: 'Donation Alert Stack',
    originalDesignName: 'Trust Fund Baby',
    effect: '+1 flat damage per 100 gold currently held',
    loreReason: 'Donations = power in Peanut\'s world',
    subcategory: 'Economy',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_pawn_shop_pawn',
    category: 'peanut_perc',
    proposedName: 'Pawn Shop Pawn',
    originalDesignName: 'Pawn Shop Pawn',
    effect: 'Every 1000 gold spent → +1 max HP permanently',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Economy',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },

  // ─── PEANUT PERCS — Anti-Elite ────────────────────────────────────────────
  {
    id: 'perc_timmy_repellent_boots',
    category: 'peanut_perc',
    proposedName: 'Bully Boots',
    originalDesignName: 'Giant Slayer Sandals',
    effect: '+5% damage vs named elites per stack (brawlers, crowned elites)',   // 23.55 — Timmy deleted; targets the brawler archetype
    loreReason: 'Direct brawler counter',
    subcategory: 'Anti-Elite',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_nickmercjerk_spray',
    category: 'peanut_perc',
    proposedName: 'Jerky Spray',
    originalDesignName: 'Boss Killer Cologne',
    effect: '+20% crit chance vs named elite enemies',
    loreReason: 'Beef Jerky is already an ultra — this is the perc version',
    subcategory: 'Anti-Elite',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },

  // ─── PEANUT PERCS — Movement ──────────────────────────────────────────────
  {
    id: 'perc_silly_spin',
    category: 'peanut_perc',
    proposedName: 'The Silly Spin',
    originalDesignName: 'Spin Move',
    effect: '+15% movement speed while moving diagonally',
    loreReason: '"Mister silly, what are you doing here mister silly"',
    subcategory: 'Movement',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_sprint_burst',
    category: 'peanut_perc',
    proposedName: 'Sprint Burst',
    originalDesignName: 'Sprint Burst',
    effect: '+30% movement speed for 3s after taking damage',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Movement',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'perc_phase_step',
    category: 'peanut_perc',
    proposedName: 'Phase Step',
    originalDesignName: 'Phase Step',
    effect: '15% chance to phase through enemy contact damage',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Movement',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },

  // ─── BUNCHA BULLSHIIII — Active Abilities ─────────────────────────────────
  {
    id: 'bull_voodoo_iv_drip',
    category: 'buncha_bullshiiii',
    proposedName: 'VooDoo Ranger IV Drip',
    originalDesignName: 'Stim Shot Mk II',
    effect: 'Active: heal 40% of max HP instantly. 45s cooldown.',
    loreReason: 'VooDoo Ranger = his healing potion',
    subcategory: 'Active Ability',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'bull_banana_peel_bomb',
    category: 'buncha_bullshiiii',
    proposedName: 'Banana Peel Bomb',
    originalDesignName: 'Banana Peel Bomb',
    effect: 'Active: place a trap that knocks back all enemies in 200wu. 20s cooldown.',
    loreReason: 'Already funny — keep as-is',
    subcategory: 'Active Ability',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'bull_whoopie_cushion',
    category: 'buncha_bullshiiii',
    proposedName: 'Whoopie Cushion of Doom',
    originalDesignName: 'Whoopie Cushion of Doom',
    effect: 'Active: stun all enemies within 250wu for 2s. 30s cooldown.',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Active Ability',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'bull_waters_fine_floatie',
    category: 'buncha_bullshiiii',
    proposedName: 'Waters Fine Floatie',
    originalDesignName: 'Inflatable Pool Floatie',
    effect: 'Passive: once per run, survive a killing blow at 25% HP instead',
    loreReason: '"Come on in, the water\'s fine" — his merch shirt catchphrase',
    subcategory: 'Active Ability',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },

  // ─── BUNCHA BULLSHIIII — Minions/Pets ────────────────────────────────────
  {
    id: 'bull_goopzilla_jr',
    category: 'buncha_bullshiiii',
    proposedName: 'Goopzilla Jr.',
    originalDesignName: 'Buddy The Squirrel',
    effect: 'Orbiting drone fires 1 shot/s at nearest enemy (scales with attack speed)',
    loreReason: 'Goopzilla = the Bungulator faction mascot monster',
    subcategory: 'Minion/Pet',
    spriteType: 'needs_animation',
    notes: '',
    approved: false,
  },
  {
    id: 'bull_follow_me_crew',
    category: 'buncha_bullshiiii',
    proposedName: 'Follow Me Crew',
    originalDesignName: 'Cousin Larry The Stalker',
    effect: 'Melee follower trails player and bites enemies for 15 damage/s',
    loreReason: '"Follow me crew" — his call to his followers',
    subcategory: 'Minion/Pet',
    spriteType: 'needs_animation',
    notes: '',
    approved: false,
  },
  {
    id: 'bull_karen_the_manager',
    category: 'buncha_bullshiiii',
    proposedName: 'Karen The Manager',
    originalDesignName: 'Karen The Manager',
    effect: '5% chance per kill to spawn a temporary ally for 10s',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Minion/Pet',
    spriteType: 'needs_animation',
    notes: '',
    approved: false,
  },

  // ─── BUNCHA BULLSHIIII — Traps/Placement ─────────────────────────────────
  {
    id: 'bull_squeaky_floorboard',
    category: 'buncha_bullshiiii',
    proposedName: 'Squeaky Floorboard',
    originalDesignName: 'Squeaky Floorboard',
    effect: 'Placeable trap — stuns first enemy that walks over it for 3s',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Trap/Placement',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'bull_pee_puddle',
    category: 'buncha_bullshiiii',
    proposedName: 'Pee Puddle',
    originalDesignName: 'Pee Puddle',
    effect: 'Placeable AOE slow zone — enemies move at 50% speed while inside',
    loreReason: 'Fits the crude register perfectly',
    subcategory: 'Trap/Placement',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },

  // ─── BUNCHA BULLSHIIII — Status Appliers ─────────────────────────────────
  {
    id: 'bull_big_mac_special_sauce',
    category: 'buncha_bullshiiii',
    proposedName: 'Big Mac Special Sauce',
    originalDesignName: 'Habanero Sauce',
    effect: 'All hits apply burn: 5% max HP/s for 3s',
    loreReason: 'Big Mac = his signature food',
    subcategory: 'Status Applier',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'bull_write_that_down',
    category: 'buncha_bullshiiii',
    proposedName: 'Write That Down',
    originalDesignName: 'Sticky Note Of Shame',
    effect: 'Hits mark enemies; marked enemies take +25% damage from all sources',
    loreReason: '"WRITE THAT DOWN! WRITE THAT DOWN!!" — his hype phrase',
    subcategory: 'Status Applier',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'bull_stay_frosty',
    category: 'buncha_bullshiiii',
    proposedName: 'Stay Frosty',
    originalDesignName: 'Ice Cube Tray',
    effect: 'All hits apply slow: enemies move at 70% speed for 2s',
    loreReason: '"Stay Frosty" — his merch hoodie / catchphrase',
    subcategory: 'Status Applier',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },

  // ─── BUNCHA BULLSHIIII — Anti-Counter ────────────────────────────────────
  {
    id: 'bull_timmy_repellent_spray',
    category: 'buncha_bullshiiii',
    proposedName: 'Bully Spray',
    originalDesignName: 'Bully Spray',
    effect: 'After taking damage from a brawler, they avoid you for 3s',   // 23.55 — Timmy deleted; targets the brawler archetype
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Anti-Counter',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  // 23.39 — bull_caseoh_moms_cooking content entry deleted (CaseOh purge).

  // ─── BUNCHA BULLSHIIII — Cursed/High-Risk ────────────────────────────────
  {
    id: 'bull_liar_deceiver',
    category: 'buncha_bullshiiii',
    proposedName: 'Liar, Deceiver, False Prophet',
    originalDesignName: "Cursed Monkey's Paw",
    effect: '+50% damage permanently, but lose 5 max HP every 60s',
    loreReason: '"Liar, Deceiver, false Prophet!" — his betrayal phrase',
    subcategory: 'Cursed/High-Risk',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'bull_mystery_meat_stew',
    category: 'buncha_bullshiiii',
    proposedName: 'Mystery Meat Stew',
    originalDesignName: 'Mystery Meat Stew',
    effect: 'Applies a random peanut perc effect every 30s (good or bad)',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Cursed/High-Risk',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },

  // ─── SHRINES — New Types ──────────────────────────────────────────────────
  {
    id: 'shrine_lock_in',
    category: 'shrine',
    proposedName: 'Lock In Shrine',
    originalDesignName: 'Honeymoon Shrine',
    effect: 'First 60s after activation: +50% damage dealt, -50% damage taken',
    loreReason: '"LOCK IN" — his hype phrase for the opening rush',
    subcategory: 'Buff Shrine',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'shrine_write_that_down',
    category: 'shrine',
    proposedName: 'Write That Down Shrine',
    originalDesignName: 'Re-Spec Shrine',
    effect: 'Refund 1 peanut perc level — choose a fresh replacement',
    loreReason: '"WRITE THAT DOWN" — take notes, try again',
    subcategory: 'Re-Spec Shrine',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'shrine_bungulators_workshop',
    category: 'shrine',
    proposedName: "Bungulator's Workshop",
    originalDesignName: "Tinkerer's Shrine",
    effect: 'Replace 1 equipped weapon with a random new weapon of same tier',
    loreReason: 'Bungulators tinker with gear',
    subcategory: 'Tinkerer Shrine',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'shrine_false_prophets_deal',
    category: 'shrine',
    proposedName: "False Prophet's Deal",
    originalDesignName: "Devil's Bargain",
    effect: '-30% max HP permanently, +50% damage permanently',
    loreReason: '"Liar, Deceiver, false Prophet!" — his betrayal phrase',
    subcategory: "Devil's Bargain",
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'shrine_doctors_pact',
    category: 'shrine',
    proposedName: "Doctor's Pact",
    originalDesignName: "Doctor's Pact",
    effect: 'Lose 1 level from a chosen peanut perc, gain 2 levels on another',
    loreReason: 'Already perfect — keep as-is',
    subcategory: "Doctor's Pact",
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'shrine_holy_trinity',
    category: 'shrine',
    proposedName: 'Holy Trinity Shrine',
    originalDesignName: 'Holy Trinity Shrine',
    effect: '+15% damage if 3 or more weapons are equipped',
    loreReason: 'Already perfect — keep as-is',
    subcategory: 'Specialist Shrine',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'shrine_the_grind',
    category: 'shrine',
    proposedName: 'The Grind Shrine',
    originalDesignName: 'Specialist Shrine',
    effect: '+30% damage bonus applied to your highest-DPS weapon only',
    loreReason: '"The Grind" — commit to one thing',
    subcategory: 'Specialist Shrine',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
  {
    id: 'shrine_by_the_gods',
    category: 'shrine',
    proposedName: 'By The Gods Shrine',
    originalDesignName: 'Blood Moon Shrine',
    effect: 'Available after minute 5: +100% damage dealt AND taken for 60s',
    loreReason: '"By the gods..." — late-game desperation play',
    subcategory: 'Blood Moon Shrine',
    spriteType: 'sprite_only',
    notes: '',
    approved: false,
  },
];

export const CATEGORIES: { id: ContentCategory; label: string; color: string }[] = [
  { id: 'weapon',           label: '🔫 Weapons',           color: '#ef4444' },
  { id: 'peanut_perc',      label: '💊 Peanut Percs',      color: '#a855f7' },
  { id: 'buncha_bullshiiii',label: '🎁 Buncha Bullshiiii', color: '#f59e0b' },
  { id: 'shrine',           label: '⛩️ Shrines',           color: '#06b6d4' },
  { id: 'enemy',            label: '👾 Enemies',           color: '#22c55e' },
];

export const SPRITE_TYPE_OPTIONS: { value: SpriteType; label: string; color: string }[] = [
  { value: 'undecided',      label: '❓ Undecided',        color: '#6b7280' },
  { value: 'sprite_only',    label: '🖼️ Sprite Only',      color: '#22c55e' },
  { value: 'needs_animation',label: '🎬 Needs Animation',  color: '#f59e0b' },
];
